import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "iodine-padding-md references-detail-title" }
const _hoisted_2 = { class: "iodine-padding-left-xs" }

export interface Props {
        bookDescription?: string
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesDetailTitle',
  props: {
    bookDescription: { default: '' }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Book: " + _toDisplayString(props.bookDescription), 1)
  ]))
}
}

})